import { config, library } from '@fortawesome/fontawesome-svg-core';

config.autoAddCss = false;

import '@fortawesome/fontawesome-svg-core/styles.css';
import * as BrandIcons from '@fortawesome/free-brands-svg-icons';
import * as SolidIcons from '@fortawesome/free-solid-svg-icons';

const solidIconsList = Object.keys(SolidIcons).reduce((acc, key) => {
  const value = SolidIcons[key as keyof typeof SolidIcons];

  if (acc.find((icon) => icon.iconName === (value as SolidIcons.IconLookup)?.iconName)) {
    return acc;
  }

  if (['fas', 'prefix'].indexOf(key) === -1) {
    acc.push(value as SolidIcons.IconDefinition);
  }
  return acc;
}, [] as SolidIcons.IconDefinition[]);

const brandIconsList = Object.keys(BrandIcons).reduce((acc, key) => {
  const value = BrandIcons[key as keyof typeof BrandIcons];
  if (acc.find((icon) => icon.iconName === (value as BrandIcons.IconLookup)?.iconName)) {
    return acc;
  }

  if (['fab', 'prefix'].indexOf(key) === -1) {
    acc.push(value as BrandIcons.IconDefinition);
  }
  return acc;
}, [] as BrandIcons.IconDefinition[]);

library.add(...solidIconsList);
library.add(...brandIconsList);
